// Datei: src/App.js

import React, { useState } from "react";
import fetchNutritionFromGPT from "./api/gpt";
import "./App.css";
import logo from "./logo.png";

function App() {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
      setImage(reader.result);
      setResult(null);
    };
    reader.readAsDataURL(file);
  };

  const handleAnalyze = async () => {
    if (!image) return;
    setLoading(true);
    try {
      const result = await fetchNutritionFromGPT(image);
      setResult(result);
    } catch (err) {
      alert("Fehler bei der Analyse. Bitte versuche es erneut.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app">
      <img src={logo} alt="BestForm Logo" className="logo" />
      <h2>Bild hochladen:</h2>
      <input type="file" accept="image/*" onChange={handleFileChange} />
      {preview && <img src={preview} alt="Preview" className="preview" />}
      {image && (
        <button onClick={handleAnalyze} disabled={loading}>
          {loading ? "Analyse läuft..." : "Analysieren"}
        </button>
      )}

      {result && (
        <table className="nutrition-table">
          <thead>
            <tr>
              <th>Nährwert</th>
              <th>Wert</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kalorien</td>
              <td>{result.calories}</td>
            </tr>
            <tr>
              <td>Eiweiß</td>
              <td>{result.protein}</td>
            </tr>
            <tr>
              <td>Fett</td>
              <td>{result.fat}</td>
            </tr>
            <tr>
              <td>Kohlenhydrate</td>
              <td>{result.carbs}</td>
            </tr>
            <tr>
              <td>Ballaststoffe</td>
              <td>{result.fiber}</td>
            </tr>
            <tr>
              <td>Kaloriendichte</td>
              <td>{result.caloricDensity}</td>
            </tr>
            <tr>
              <td>Sättigungsscore</td>
              <td>{result.satietyScore}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
}

export default App;

